/* Keeps the drawn outline glued to the violet tile: the SVG viewBox is kept at the box's own
   pixel size so the corner radius matches exactly instead of being stretched. */
(function () {
  'use strict';

  function sync(box) {
    var svg = box.querySelector('.pe-cat__ring');
    if (!svg) return;
    var w = Math.round(box.clientWidth);
    var h = Math.round(box.clientHeight);
    if (!w || !h) return;
    var key = w + 'x' + h;
    if (svg.getAttribute('data-size') === key) return;
    svg.setAttribute('data-size', key);
    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    var radius = parseFloat(getComputedStyle(box).borderTopLeftRadius) || 14;
    var rects = svg.querySelectorAll('rect');
    for (var i = 0; i < rects.length; i++) {
      rects[i].setAttribute('x', '1');
      rects[i].setAttribute('y', '1');
      rects[i].setAttribute('width', String(Math.max(0, w - 2)));
      rects[i].setAttribute('height', String(Math.max(0, h - 2)));
      rects[i].setAttribute('rx', String(Math.max(0, radius - 1)));
    }
  }

  function syncAll() {
    var boxes = document.querySelectorAll('.pe-cat__box');
    for (var i = 0; i < boxes.length; i++) sync(boxes[i]);
  }

  function watch() {
    syncAll();
    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) sync(entries[i].target);
      });
      var boxes = document.querySelectorAll('.pe-cat__box');
      for (var j = 0; j < boxes.length; j++) ro.observe(boxes[j]);
    } else {
      window.addEventListener('resize', syncAll);
    }
    window.addEventListener('load', syncAll);
  }

  if (document.readyState !== 'loading') watch();
  else document.addEventListener('DOMContentLoaded', watch);
})();
